export default "\n.summary-list-card[data-v-22c0076e] {\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\n}\r\n"